module.exports = __webpack_public_path__ + "static/img/12en.eb0be60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/12en.png
// module id = 82ka
// module chunks = 0